import React from "react";
import {Dialog} from "@mui/material";
import DialogTitle from "@mui/material/DialogTitle";
import {useTranslation} from "react-i18next";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import {DeleteButton} from "../buttons/DeleteButton";

export function DeleteDialog(props: {
  open: boolean,
  itemName?: string,
  onClose: () => any,
  onConfirm: () => any
}) {
  const {t} = useTranslation();

  return (
    <Dialog
      open={props.open}
      onClose={props.onClose}
    >
      <DialogTitle>{t('DeleteDialog.title') + ' ' + (props.itemName || '') + '?'}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {t('DeleteDialog.message')}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onClose} color="primary">
          {t('buttons.cancel')}
        </Button>
        <DeleteButton onClick={props.onConfirm}/>
      </DialogActions>
    </Dialog>
  );
}
